import { useEffect, useState } from "react";

export default function useDevice() {
  const [isMobile, setIsMobile] = useState<boolean>();

  useEffect(() => {
    if (typeof window !== "undefined" && isMobile !== undefined) {
      const listener = () => {
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
      };
      listener();
      window.addEventListener("resize", listener);
      return () => {
        window.removeEventListener("resize", listener);
      };
    }
  }, [setIsMobile, isMobile]);

  return {
    isMobile,
  };
}
